import { render, staticRenderFns } from "./ProcessedData.vue?vue&type=template&id=573b31cb&scoped=true&"
import script from "./ProcessedData.vue?vue&type=script&lang=js&"
export * from "./ProcessedData.vue?vue&type=script&lang=js&"
import style0 from "./ProcessedData.vue?vue&type=style&index=0&id=573b31cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573b31cb",
  null
  
)

export default component.exports